<template>
  <app-filter-group
      ref="inputRadio"
      @query="search"
      :query-loading="queryLoading"
      @reset="reset">
    <!-- <app-filter-item>
      <gj-radio-group
          v-model="filter.groupType"
          :options="[
            {id: 'asin', text: 'ASIN'},
            {id: 'variationAsin', text: '父ASIN'},
            {id: 'msku', text: 'MSKU'},
            {id: 'shop', text: '店铺'},
          ]"
         
          @input="changeGroupType"
      ></gj-radio-group>
    </app-filter-item> -->
    <app-filter-item>
      <gj-country-server-select
          :width="clientWidth > 1366 ? ['140px', '170px'] : ['110px', '150px']"
          v-model="filter.countryAndMarket"
      ></gj-country-server-select>
    </app-filter-item>
    <app-filter-item
        v-if="showCurrency"
        style="margin-left: 8px;">
      <gj-select
          v-model="filter.currency"
          :options="option.statisticsCurrency"
          :clearable="false"
      ></gj-select>
    </app-filter-item>
    <app-filter-item>
      <gj-select-input
          :value="filter.keyword"
          :options="option.keywordOption"
          :width="clientWidth > 1366 ? ['90px', '110px'] : ['90px', '90px']"
      ></gj-select-input>
    </app-filter-item>
    <app-filter-item>
      <gj-date-picker
          v-model="filter.date"
          type="daterange"
          :clearable="false"
      ></gj-date-picker>
    </app-filter-item>
    <slot></slot>
    <template #right>
      <slot name="right"></slot>
      <view-setting
          :ref="REF_VIEW_SETTING"
          save-mode="remote"
          :use-default="true"
          :module-name="moduleName"
          :config="model"
          :fn-generate-params="generateViewParams"
          @view-change="handleChangeView"
          @view-complete="handCompleteView"
      >

      </view-setting>
    </template>
    <template #advancedFilter>
      <gj-charger-select
          v-model="filter.chargeIdList"
          collapse-tags
          placeholder="全部负责人"
          style="width: 170px"
      ></gj-charger-select>
      <gj-category-select
          v-model="filter.categoryIds"
          collapse-tags
          multiple
          placeholder="全部品类"
          width="190px">
      </gj-category-select>
      <gj-brand-select
          v-model="filter.brandId"
          placeholder="全部品牌"
          width="150px">
      </gj-brand-select>
    </template>
  </app-filter-group>
</template>

<script>
import {financeCurrencysOption} from "@/utils/options";
import {convertToDate, generateViewParams} from "@/utils/date.util";
import {DATE_SHORTCUTS} from "@/utils/const";
import {queryMixin} from "@/minxins";
import viewConfig from './viewConfig'
// import _ from 'lodash'

export default {
  name: "listing-analysis-filter-new",
  mixins: [queryMixin],
  props: {
    asinType: {
     type: String,
      default: ""
    },
    filter: {
      type: Object,
      default() {
        return {}
      }
    },
    initDate: {
      default: () => DATE_SHORTCUTS.yesterday.date
    },
    showCurrency: {
      type: Boolean,
      default: true
    },
    queryLoading: {
      required: false
    }
  },
  computed: {
    model({viewConfig, showCurrency}) {
      const model = viewConfig.call(this)
      return model.filter(v => (v.prop !== 'currency' || showCurrency))
    },
    moduleName() {
      return `LISTING_ANALYSIS_FILER_${this.$route.name}`
    }
  },
  data() {
    return {
      option: {
        statisticsCurrency: financeCurrencysOption,
        keywordOption: [
          {id: 'asin', text: 'ASIN'},
          {id: 'variationAsin', text: '父ASIN'},
          {id: 'sku', text: 'SKU'},
          {id: 'msku', text: 'MSKU'},
        ]
      },
      // filter:{},
      viewConfig,
      groupType: ""
    }
  },
  created() {
    // this.filter =  _.cloneDeep(this.filters)
    this.filter.date = this.initDate;
    this.init();

    
  },
  watch: {
    initDate() {
      this.filter.date = this.initDate;
    },
    // filter(){
    //   console.log('asinType:',this.asinType)
    // },

    // 'filter.groupType': function (newVal, oldVal) {
    //    this.changeGroupType(newVal)
    // },

    asinType(){
      if(this.asinType !== 'SHOP' && this.groupType !== this.asinType){
        this.init();
      }
    }
  },
  methods: {
    init(){
        this.groupType = this.asinType;
        this.changeGroupType(this.asinType)
    },
    generateViewParams,
    handCompleteView(view) {
      let params
      let cacheData = this.getCacheData() || {}
      if (cacheData.query && JSON.stringify(cacheData.query) !== '{}') {
        params = cacheData.query
        this.$emit('set-pagination', cacheData.pagination || {})
      } else if (view && view.params) {
        params = JSON.parse(view.params)
      }
      this.mergeRemoteParams(params || {})
      this.search('finish')
    },
    /**
     * 切换视图
     */
    async handleChangeView(view) {
      if (view && view.params) {
        try {
          let params = JSON.parse(view.params)
          if (params && this.mergeRemoteParams && typeof this.mergeRemoteParams === 'function') {
            this.mergeRemoteParams(params)
          }

          this.search()
        } catch (e) {
          console.warn(e)
        }
      } else {
        this.reset()
      }

    },
    /**
     * 设置全局查询参数
     */
    mergeRemoteParams(params) {
      const date = params.date ? params.date : params.startDateTime && params.endDateTime ? [params.startDateTime, params.endDateTime] : this.filter.date
      Object.assign(this.filter, {
        ...params,
        date
      })
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{groupType: *, countryAndMarket: *}}
     */
    $gjCacheCallback(params) {
      return {
        groupType: params.groupType,
        countryAndMarket: params.countryAndMarket
      };
    },
    search(type = 'search') {
      // 类型切换时，清空
      this.option.keywordOption.forEach(item => {
          this.filter[item.id] = '';
      })
      const params = {
        ...this.filter,
        startStatisticsDate: convertToDate(this.filter.date[0]),
        endStatisticsDate: convertToDate(this.filter.date[1]),
      };
      // 当不是重置时，重新给所搜索类型复制
      if(type !== 'reset'){
        params[this.filter.keyword.key] = this.filter.keyword.value;
      }
      if (this.filter.countryAndMarket) {
        params.countrys = this.filter.countryAndMarket.countryIds;
        params.marketIds = this.filter.countryAndMarket.marketIds;
      }
      this.$nextTick(() => {
        this.$emit(type, params, this.filter);
      })
    },
    changeGroupType(type) {
      if (type == 'shop') {


      }else{
        this.filter.keyword.value = '';
        // 维度切换时，删除之前所有维度选择选项
        this.option.keywordOption.forEach(item => {
          this.filter[item.id] = '';
        })
        if (this.filter.groupType === 'msku') {
          this.option.keywordOption = [
            {id: 'asin', text: 'ASIN'},
            {id: 'variationAsin', text: '父ASIN'},
            {id: 'sku', text: 'SKU'},
            {id: 'msku', text: 'MSKU'},
          ];
          this.filter.keyword.key = 'asin';
        } else if (this.filter.groupType === 'asin') {
          this.option.keywordOption = [
            {id: 'asin', text: 'ASIN'},
            {id: 'variationAsin', text: '父ASIN'},
            {id: 'sku', text: 'SKU'},
          ];
          this.filter.keyword.key = 'asin';
        } else {
          this.option.keywordOption = [
            {id: 'variationAsin', text: '父ASIN'},
          ];
          this.filter.keyword.key = 'variationAsin';
        }
        if (type !== 'reset') {
          this.search();
        }
      }
    },
    reset() {
      this.filter.currency = '';
      this.filter.categoryIds = null;
      this.filter.brandId = null;
      this.filter.chargeIdList = null;
      this.filter.date = this.initDate;
      this.filter.userPermission = null;
      if (this.filter.countryAndMarket) {
        this.filter.countryAndMarket.countryIds = null;
        this.filter.countryAndMarket.marketIds = null;
      }
      this.search('reset');
      this.changeGroupType('reset');
    }
  }
}
</script>

<style scoped>

</style>
